import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import View from "./View";
import FBTV from "./FBTV";
import RawView from "./RawView";
import ProvidersStatus from "./ProvidersStatus";

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter([
    {
        path: "/view",
        element: <View/>,
    },
    {
        path: "/raw-view",
        element: <RawView/>,
    },
    {
        path: "/view-fb",
        element:<FBTV/> ,
    },
    {
        path: "/status",
        element: <ProvidersStatus/>,
    },
    {
        path: "/",
        element: <App/>,
    },
]);

root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
